import { toUsdStr } from 'pared/utils/number'

import { IListLocationInboundCalls } from './gql'

const parseSummary = (
  data: IListLocationInboundCalls,
  locationName: string,
  options?: {
    isForExray: boolean
  },
) => {
  const inboundCallsData = data?.listLocationInboundCalls?.nodes?.[0]
  const employeeCallsData = data?.listLocationEmployeeCalls?.nodes

  const parsedSummary: {
    summaryMessage: string | React.ReactElement
    areasOfImprovementMessages: (string | React.ReactElement)[]
    annualOpportunityCost: number
    warningLevel: number
  } = {
    summaryMessage: '',
    areasOfImprovementMessages: [],
    annualOpportunityCost: 0,
    warningLevel: 1,
  }

  const selectedTimePeriodString = options?.isForExray
    ? 'the past 30 days'
    : 'the time period selected'

  if (inboundCallsData?.inboundTotal) {
    const {
      percentAnswered,
      brandPercentAnswered,
      missedOpportunity,
      annualOpportunityCost,
    } = inboundCallsData

    if (percentAnswered > brandPercentAnswered) {
      parsedSummary.warningLevel = 1
      parsedSummary.summaryMessage = `Great job! ${locationName} is answering ${percentAnswered.toFixed(
        1,
      )}% of calls which is higher than company averages for ${selectedTimePeriodString}.`
    } else {
      parsedSummary.warningLevel = 4
      parsedSummary.summaryMessage = `Anyone home? ${locationName} is performing worse than company averages and only answering ${percentAnswered.toFixed(
        1,
      )}% of calls.`
    }

    if (missedOpportunity) {
      const missedOpportunityDollars = toUsdStr(
        parseInt(missedOpportunity) / 100,
      )
      parsedSummary.summaryMessage += ` Missed calls are a ${missedOpportunityDollars} opportunity for ${selectedTimePeriodString}.`
    }

    if (annualOpportunityCost) {
      parsedSummary.annualOpportunityCost =
        parseInt(annualOpportunityCost) / 100
    }
  } else {
    parsedSummary.summaryMessage = `No calls in ${selectedTimePeriodString}.`
  }

  if (Array.isArray(employeeCallsData) && employeeCallsData.length > 0) {
    const employeeWithHighestMissPercent = employeeCallsData.reduce(
      (acc, cur) =>
        cur.percentMissedAndAbandoned > acc.percentMissedAndAbandoned
          ? cur
          : acc,
    )
    parsedSummary.areasOfImprovementMessages.push(
      `When Manager ${
        employeeWithHighestMissPercent.employeeName
      } is on duty, ${employeeWithHighestMissPercent.percentMissedAndAbandoned.toFixed(
        1,
      )}% of calls were missed or abandoned in ${selectedTimePeriodString}, the highest rate.`,
    )
  }

  return parsedSummary
}

export default parseSummary
